/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { ApiRef, createApiRef } from '@backstage/core-plugin-api';
import { Observable } from '@backstage/types';

/**
 * An API to store starred Docs
 *
 * @public
 */
export const starredDocsApiRef: ApiRef<StarredDocsApi> = createApiRef({
  id: 'techdocs-addon.starred-docs',
});

/**
 * An API to store and retrieve starred Docs
 *
 * @public
 */
export interface StarredDocsApi {
  /**
   * Toggle the star state of the doc
   *
   * @param docRef - doc reference to toggle
   */
  toggleStarred(docRef: DocRef): Promise<void>;

  /**
   * Observe the set of starred doc references.
   */
  starredDoc$(): Observable<DocRef[]>;
}

export type DocRef = {
  key: string;
  name: string;
  path: string;
};
